import { TriangleIcon } from "./MiscInterfaceIcons";
export const SvgVibescoutIcons = {
    TriangleIcon
};
